module.exports = __webpack_public_path__ + "static/PostIT_Single-cd199729530b6cf446807030d993a33d.png";